"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kantime = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class Kantime {
    constructor() { }
    /**********************************************************************************************************************
     *                     START : KANTIME Software Parser
     * ********************************************************************************************************************/
    /**
     * @function parse
     * @param pastedData
     * @param event
     * @param callbackEmit
     * @summary KantimeHospiceSoftwareParser Software Parser @pastedData string break by session to session
     * @returns {callback}
     */
    parse(pastedData, event, callbackEmit) {
        var _a, _b;
        /**Default Value*/
        this.fromPDF = false;
        //Identify Copy from data
        if (pastedData.indexOf("Patient Information") != -1 &&
            pastedData.indexOf("Living Situation:") != -1) {
            /**Copy From PDF*/
            this.fromPDF = true;
        }
        else {
            /**Copy From WEBSITE*/
            this.fromPDF = false;
        }
        try {
            let sendCallBackData;
            if (this.fromPDF) {
                sendCallBackData = this.copyPastedFromPDF(pastedData);
            }
            else {
                sendCallBackData = this.copyPastedFromWebsite(pastedData);
            }
            const mrn = (_b = (_a = pastedData
                .match(/Patient Id:\s*([A-Za-z0-9]+)/i)) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.trim();
            //@callback
            callbackEmit({
                parseData: Object.assign(Object.assign({}, sendCallBackData), (mrn && { mrn })),
            });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error.message : error,
                errorStack: error.stack,
            });
        }
    }
    /**
     * @function copyPastedFromWebsite
     * @param pastedData
     * @returns {Object}
     * @summary If user copy pasted data from kantime website
     */
    copyPastedFromWebsite(pastedData) {
        //**Session 1 Patient name*/
        const sessionFirst = (0, helper_1.substrInBetween)(pastedData, "Patient Id:", "Place of Service:");
        //**Patient Information*/
        const patientInfo = this.gettingPatientDetails(sessionFirst);
        //**Session 6 Emergency Contact*/
        const sessionSix = (0, helper_1.substrInBetween)(pastedData, "Emergency Contacts", "Patient Other Info");
        //**Session 7 Primary Physician*/
        const sessionSeven = (0, helper_1.substrInBetween)(pastedData, "Physician / Hospital Info", "Patient Other Info");
        //**Session 8 Pharmacy*/
        const sessionEight = (0, helper_1.substrInBetween)(pastedData, "Resumption of Care", "Missed Visit Order Default Clinician:");
        const physicianInfo = this.getPrimaryPhysician(sessionSix, sessionSeven, sessionEight);
        //**Session 9 Comments*/
        const sessionNine = (0, helper_1.substrInBetween)(pastedData, "Client Notes", "Client Alert");
        const comment = this.getComment(sessionNine);
        return Object.assign(Object.assign(Object.assign({}, patientInfo), physicianInfo), comment);
    }
    /**
     * @function copyPastedFromPDF
     * @param pastedData
     * @returns {Object}
     * @summary If user copy pasted data from PDF
     */
    copyPastedFromPDF(pastedData) {
        //**Session 1 Patient name*/
        const sessionFirstPre = (0, helper_1.substrInBetween)(pastedData, "Client:", "Patient ID:");
        const sessionFirst = (0, helper_1.substrInBetween)(pastedData, "Intake Notes:", "Classification:");
        //**Patient Information*/
        const patientInfo = this.gettingPatientDetails(`${sessionFirstPre} Status:# ${sessionFirst}`);
        //**Session 3 Insurance*/
        const sessionThird = (0, helper_1.substrInBetween)(pastedData, "Insurance Information", "Insurance ID:");
        const insurance = this.getInsurance(sessionThird);
        //**Session 6 Emergency Contact*/
        const sessionSix = (0, helper_1.substrInBetween)(pastedData, "Emercency Contacts", "Face To Face Encounter");
        //**Session 7 Primary Physician*/
        const sessionSeven = (0, helper_1.substrInBetween)(pastedData, "Attending Physician:", "Start Of Care Clinician:");
        //**Session 8 Pharmacy*/
        const sessionEight = (0, helper_1.substrInBetween)(pastedData, "Additional Pharmacies", "Patient Information");
        const physicianInfo = this.getPrimaryPhysician(sessionSix, sessionSeven, sessionEight);
        //**Session 9 Comments*/
        const sessionNine = (0, helper_1.substrInBetween)(pastedData, "Client Notes", "Client Alert");
        const comment = this.getComment(sessionNine);
        return Object.assign(Object.assign(Object.assign(Object.assign({}, patientInfo), physicianInfo), insurance), comment);
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from kantime
     */
    gettingPatientDetails(sessionFirst) {
        if (!sessionFirst) {
            return {};
        }
        //Only for website case
        if (this.fromPDF == false) {
            sessionFirst = sessionFirst.substr(0, sessionFirst.indexOf("Age:"));
        }
        let dob = sessionFirst.substring(sessionFirst.indexOf("D.O.B:") + 6);
        if (dob) {
            dob = (0, helper_1.trim)(dob);
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(sessionFirst.substr(0, sessionFirst.indexOf("Status:")))), this.patientPhoneNumberWithAddress(sessionFirst)), { email: (0, helper_1.getEmailAddress)((0, helper_1.substrInBetween)(sessionFirst, "Email:", "DL NO:")), dob: (0, helper_1.getDOB)(dob, this.fromPDF ? false : true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from kantime
     */
    getInsurance(sessionThird) {
        if (!sessionThird) {
            return {};
        }
        const convertToArray = sessionThird.split(":");
        //Primary Insurance and Secondary Insurance
        return { insurance: (0, helper_1.trim)(convertToArray[1] ? convertToArray[1] : "") };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from kantime
     */
    getPrimaryPhysician(sessionSix, sessionSeven, sessionEight) {
        const primaryPhy = {
            info: {
                physician: [
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 1,
                    },
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 2,
                    },
                ],
                pharmacy: [this.getPharmacy(sessionEight)],
                careGiver: this.getCaregiver(sessionSix),
            },
        };
        //**Note: From PDF */
        if (this.fromPDF) {
            const breakPhysician = sessionSeven.split("Primary care Physician:");
            for (const value of breakPhysician) {
                const valueBreak = (0, helper_1.trim)(value).split("\n")[0];
                const numbers = (0, helper_1.phoneNumbers)(value);
                if (!valueBreak || !numbers || !numbers.length) {
                    continue;
                }
                if (!primaryPhy.info.physician[0].name) {
                    primaryPhy.info.physician[0].name = valueBreak;
                    const firstNumber = numbers[0].replace(/[\s-()]/g, "");
                    primaryPhy.info.physician[0].phoneNo =
                        (0, helper_1.changeNumberUSFormat)(firstNumber);
                }
                else {
                    primaryPhy.info.physician[1].name = valueBreak;
                    const firstNumber = numbers[0].replace(/[\s-()]/g, "");
                    primaryPhy.info.physician[1].phoneNo =
                        (0, helper_1.changeNumberUSFormat)(firstNumber);
                    //Loop Break
                    break;
                }
            }
        }
        else {
            //**Note: From WEBSITE */
            const physicianInfo = (0, helper_1.substrInBetween)(sessionSeven, "Attending Physician", "NPI:");
            const phyInfo = (0, helper_1.substrInBetween)(physicianInfo, "Physician:", "Fax:");
            const phyInfoToArray = phyInfo.split("\n");
            primaryPhy.info.physician[0].name = phyInfoToArray[0];
            //Check `Click here to view Physician Profile` title
            if (primaryPhy.info.physician[0].name.indexOf("Click") != -1) {
                primaryPhy.info.physician[0].name =
                    primaryPhy.info.physician[0].name.split("Click")[0];
            }
            //Get Numbers
            const numbers = (0, helper_1.phoneNumbers)(phyInfo);
            if (primaryPhy.info.physician[0].name && numbers) {
                const firstNumber = numbers[0].replace(/[\s-()]/g, "");
                primaryPhy.info.physician[0].phoneNo =
                    (0, helper_1.changeNumberUSFormat)(firstNumber);
            }
        }
        //@Return
        return primaryPhy;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacyData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        if (this.fromPDF) {
        }
        else {
            //Blank data Return
            const phaInfo = (0, helper_1.substrInBetween)(data, "Pharmacy Name:", "QA Name:");
            //Return black data
            if (!phaInfo) {
                return pharmacyData;
            }
            //convert to array
            const phaInfoToArray = phaInfo.split("\n");
            if ((0, helper_1.arrayLength)(phaInfoToArray) >= 2) {
                pharmacyData.name = phaInfoToArray[0];
                //Get Numbers
                const numbers = (0, helper_1.phoneNumbers)(phaInfo);
                if (pharmacyData.name && numbers) {
                    const firstNumber = numbers[0].replace(/[\s-()]/g, "");
                    pharmacyData.phoneNo = (0, helper_1.changeNumberUSFormat)(firstNumber);
                }
            }
        }
        //@Return
        return pharmacyData;
    }
    getCaregiver(data) {
        var _a;
        const caregiverData = [
            {
                name: "",
                phoneNo: "",
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            },
            {
                name: "",
                phoneNo: "",
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 2,
            },
        ];
        //Blank data Return
        if (!data) {
            return caregiverData;
        }
        //**Note: From PDF */
        if (this.fromPDF) {
            const dataBreak = data.split("\n");
            if (dataBreak.length > 1) {
                for (let fIndex = 1; fIndex < dataBreak.length; fIndex++) {
                    let value = dataBreak[fIndex];
                    const numbers = (0, helper_1.phoneNumbers)(value);
                    if (!numbers) {
                        continue;
                    }
                    value = value.replace(numbers[0], "");
                    value = (0, helper_1.trim)(value);
                    const valueBreak = value.split(" ");
                    //Pop Primary/Secondary
                    valueBreak.pop();
                    //Pop relationship
                    const relationship = valueBreak.pop();
                    //Set
                    if (!caregiverData[0].name) {
                        caregiverData[0].name = `${valueBreak.join(" ")} (${relationship})`;
                        const firstNumber = numbers[0].replace(/[\s-()]/g, "");
                        caregiverData[0].phoneNo = (0, helper_1.changeNumberUSFormat)(firstNumber);
                    }
                    else {
                        caregiverData[1].name = `${valueBreak.join(" ")} (${relationship})`;
                        const firstNumber = numbers[0].replace(/[\s-()]/g, "");
                        caregiverData[1].phoneNo = (0, helper_1.changeNumberUSFormat)(firstNumber);
                        break;
                    }
                }
            }
        }
        else {
            //**Note: From WEBSITE */
            const dataToArray = data.split("\n");
            if (!(0, helper_1.arrayLength)(dataToArray)) {
                return caregiverData;
            }
            /**Note: 0 index always heading */
            for (let fIndex = 1; fIndex < dataToArray.length; fIndex++) {
                //Loop break if data done
                if (caregiverData[0].name && caregiverData[1].name) {
                    break;
                }
                //convert to array
                const emergencyRow = dataToArray[fIndex].split("\t");
                //Get update index
                const updateIndex = emergencyRow[3] === "Secondary" ? 1 : 0;
                caregiverData[updateIndex].name = (_a = emergencyRow[1]) !== null && _a !== void 0 ? _a : "";
                //Bind name with Relationship
                if (caregiverData[updateIndex].name && emergencyRow[2]) {
                    caregiverData[updateIndex].name += ` (${emergencyRow[2]})`;
                }
                //Bind PhoneNumber
                const numbers = (0, helper_1.phoneNumbers)(dataToArray[fIndex]);
                if (caregiverData[updateIndex].name && numbers) {
                    const firstNumber = numbers[0].replace(/[\s-()]/g, "");
                    caregiverData[updateIndex].phoneNo =
                        (0, helper_1.changeNumberUSFormat)(firstNumber);
                }
            }
        }
        //@Return
        return caregiverData;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
                apartmentNo: "",
            },
        };
        //**Note: From PDF */
        if (this.fromPDF) {
            const numbers = (0, helper_1.phoneNumbers)((0, helper_1.substrInBetween)(firstSession, "Phone:", "Cell:"));
            if (numbers && (0, helper_1.arrayLength)(numbers)) {
                const firstNumber = numbers[0].replace(/[\s-()]/g, "");
                info.phoneNo = (0, helper_1.changeNumberUSFormat)(firstNumber);
            }
            const address = (0, helper_1.substrInBetween)(firstSession, "Address:", "SSN:");
            let fullAddress = address.substr(0, address.indexOf("DOB:"));
            const breakAddress = address.split("\n");
            fullAddress += breakAddress[breakAddress.length - 1];
            info.address.placeName = fullAddress;
            //Find Apartment Number
            info.address.apartmentNo = this.findApartmentNumber(fullAddress);
        }
        else {
            //**Note: From WEBSITE */
            let pAddress = (0, helper_1.substrInBetween)(firstSession, "Address 1:", "Address 2:");
            if (pAddress.indexOf("Click to Update") != -1) {
                pAddress = pAddress.substr(0, pAddress.indexOf("Click to Update"));
            }
            if (pAddress.indexOf("Updated Lat") != -1) {
                pAddress = pAddress.substr(0, pAddress.indexOf("Updated Lat"));
            }
            //Find Apartment Number
            info.address.apartmentNo = this.findApartmentNumber(pAddress);
            //address
            if (pAddress) {
                info.address.placeName = (0, helper_1.trim)(pAddress);
            }
            //number
            const pNumber = (0, helper_1.substrInBetween)(firstSession, "Longitude:", "DL NO:");
            const numbers = (0, helper_1.phoneNumbers)(pNumber);
            if (numbers && (0, helper_1.arrayLength)(numbers)) {
                const firstNumber = (numbers[0] ? numbers[0] : numbers[1] ? numbers[1] : "").replace(/[\s-()]/g, "");
                info.phoneNo = (0, helper_1.changeNumberUSFormat)(firstNumber);
            }
        }
        //@Return address or phoneNo
        return info;
    }
    findApartmentNumber(address) {
        //Find Apartment Number
        const addressToLower = address.toLowerCase();
        let apartment = "";
        if (addressToLower.indexOf("apt") != -1) {
            const addressToArray = addressToLower.split(" ");
            for (let fIndex = 0; fIndex < addressToArray.length; fIndex++) {
                const text = addressToArray[fIndex];
                if (text.indexOf("apt") != -1) {
                    let nextText = addressToArray[fIndex + 1];
                    let nextOneText = addressToArray[fIndex + 2];
                    if (nextText) {
                        nextText = nextText.replace(",", "");
                    }
                    if (nextOneText) {
                        nextOneText = nextOneText.replace(",", "");
                    }
                    //Find number
                    if (isNaN(nextText) == false || isNaN(nextOneText) == false) {
                        apartment = isNaN(nextText) == false ? nextText : nextOneText;
                    }
                    break; //Loop Break
                }
            }
        }
        return apartment;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        //**Note: From PDF */
        if (this.fromPDF) {
            const nameBreak = sessionFirst.split(",");
            name.firstName = (0, helper_1.trim)(nameBreak[nameBreak.length - 1]);
            nameBreak.splice(nameBreak.length - 1, 1);
            name.lastName = nameBreak.join(" ");
        }
        else {
            //**Note: From WEBSITE */
            let patientName = sessionFirst.substring(sessionFirst.indexOf("Name:") + 5);
            //Value trim
            if (patientName) {
                patientName = (0, helper_1.trim)(patientName);
            }
            if (patientName) {
                const breakName = patientName.split(" ");
                //Remove prefix name
                if (breakName[0].indexOf("Dr") != -1 ||
                    breakName[0].indexOf("Miss") != -1 ||
                    breakName[0].indexOf("Mr") != -1 ||
                    breakName[0].indexOf("Mrs") != -1 ||
                    breakName[0].indexOf("Ms") != -1) {
                    breakName.splice(0, 1);
                }
                //Add firstName and remove from array
                name.firstName = breakName[0];
                breakName.splice(0, 1);
                //Add last Name
                name.lastName = breakName.join(" ");
            }
        }
        //@Return name
        return name;
    }
    /**
     * @function getComment
     * @param comment
     * @summary Getting Comment filed from kantime
     */
    getComment(comment) {
        if (comment) {
            return { about: comment };
        }
        return { about: "" };
    }
}
exports.Kantime = Kantime;
